import { withRouter } from 'react-router-dom';

function MessageProvider({message, title, options, autoclose, settings, setSelectedValue}) {
    if (!message || !message.length){
        return <></>;
    }

    return (
        <>
            <div className="modal in" 
                 id="bootstrapModal" 
                 tabIndex="-1" 
                 role="dialog" 
                 aria-labelledby="bootstrapModal" 
                 aria-hidden="true" 
                 style={{display: 'block'}}>
                <div data-view="plugins/messageBox" 
                     className="modal-dialog" 
                     data-active-view="true">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>{title}</h3>
                        </div>
                        <div className="modal-body">
                            <p className="message">{message}</p>
                        </div>
                        <div className="modal-footer">
                            {options.map(option =>
                                <button onClick={() => setSelectedValue(option)}
                                        className="btn btn-default btn-primary autofocus">{option}</button>
                            )}
                            <div style={{clear:'both'}}></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default withRouter(MessageProvider);